<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con" style="padding-top:20px;">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-select v-model="schoolPrivince" clearable placeholder="请选择省份">
            <el-option
              v-for="item in privinceData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="schoolLevel" clearable placeholder="请选择学校层次">
            <el-option
              v-for="item in SchoolLevelList"
              :key="item.value"
              :label="item.value"
              :value="item.lable"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="schoolType" clearable placeholder="请选择学校类型">
            <el-option
              v-for="item in SchoolTypeList"
              :key="item.value"
              :label="item.value"
              :value="item.lable"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="schoolName" placeholder="学校名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <a class="export-button-a" style="color:#fff" :href="exportExcelStu">导出</a>
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="siteList" @selection-change="handleSelectionChange" style="width: 100%;margin-left:30px;">
      <!-- <el-table-column prop="Id"  :reserve-selection="true" width="55"></el-table-column> -->
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="schoolName" label="学校名称" show-overflow-tooltip width="300"></el-table-column>
      <el-table-column prop="dateCreated" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="province" label="省份" show-overflow-tooltip>
      </el-table-column>
       <el-table-column prop="schoolLevel" label="学校层次" show-overflow-tooltip >
        <template slot-scope="scope">
          <span v-if="scope.row.schoolLevel == 1">中职</span>
          <span v-if="scope.row.schoolLevel == 2">高职</span>
          <span v-if="scope.row.schoolLevel == 3">本科</span>
        </template>
      </el-table-column>
      <el-table-column prop="schoolType" label="学校类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.schoolType == 1">国示范</span>
          <span v-if="scope.row.schoolType == 2">省示范</span>
          <span v-if="scope.row.schoolType == 3">行业特色校</span>
          <span v-if="scope.row.schoolType == 4">优质校</span>
          <span v-if="scope.row.schoolType == 5">本科</span>
        </template>
      </el-table-column>

      <el-table-column prop="responNameOrJob" label="负责人姓名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="phone" label="负责人手机" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createUserName" label="账号" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          
          <el-button type="primary" size="mini" @click="goLook(scope.row.id)">查看</el-button>
          <!-- <el-button type="danger" size="mini">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100,200,500,1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolLevel: "",
      schoolType: "",
      schoolPrivince: "",
      // 省份
      privinceData: "",
      //1、 中职 2、高职 3、本科
      SchoolLevelList: [
        {
          lable: 1,
          value: "中职"
        },
        {
          lable: 2,
          value: "高职"
        },
        {
          lable: 3,
          value: "本科"
        }
      ],
      //1、 国示范 2、省示范 3、行业特色校  4、优质校  5 本科
      SchoolTypeList: [
        {
          lable: 1,
          value: "国示范"
        },
        {
          lable: 2,
          value: "省示范"
        },
        {
          lable: 3,
          value: "行业特色校"
        },
        {
          lable: 4,
          value: "优质校"
        },
        {
          lable: 5,
          value: "本科"
        }
      ],
      schoolName: "",
      siteList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0
    };
  },
  components: {},
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    exportExcelStu: function() {
      return "/api/XOrg/QuestionnaireManager/exportSiteExcel?schoolName="+ this.schoolName+"&schoolLevel="+this.schoolLevel+"&schoolType="+this.schoolType+"&schoolPrivince="+this.schoolPrivince+"&certificateId="+this.certificateId;
    }
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getSessionStorage();
    this.getPilotList();
    this.getProvinceData();
  },
  methods: {
    getProvinceData() {
      this.$http
        .post("/api/XOrg/Questionnaire/getAllProvinceList")
        .then(res => {
          if (res.code > 0) {
            this.privinceData = res.province;
          }
        });
    },
    goLook(id) {
      debugger;
      this.$router.push({
        name: "declareSite",
        params: {
          id: id
        }
      });
    },
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPilotList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getPilotList();
    },
    search() {
      this.page = 1;
      this.getPilotList();
    },
    getPilotList() {
      var that = this;
      this.$http
        .post("/api/XOrg/QuestionnaireManager/getQuestionnaireList", {
          schoolName: that.schoolName,
          schoolLevel: that.schoolLevel,
          schoolType: that.schoolType,
          schoolPrivince: that.schoolPrivince,
          certificateId:that.certificateId,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          that.siteList = rst.list;
          that.page = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;

          // 参数存储本地缓存
          sessionStorage.setItem("wlx_pilotManager_schoolName",that.schoolName);
          sessionStorage.setItem("wlx_pilotManager_schoolLevel",that.schoolLevel);
          sessionStorage.setItem("wlx_pilotManager_schoolType",that.schoolType);
          sessionStorage.setItem("wlx_pilotManager_schoolPrivince",that.schoolPrivince);
          sessionStorage.setItem("wlx_pilotManager_pageSize",that.pageSize);
          sessionStorage.setItem("wlx_pilotManager_page",that.page);
        });
    },
    // 获取网页缓存信息
    getSessionStorage(){
      // 获取网页缓存信息
      var schoolName = sessionStorage.getItem("wlx_pilotManager_schoolName");
      var schoolLevel = sessionStorage.getItem("wlx_pilotManager_schoolLevel");
      var schoolType = sessionStorage.getItem("wlx_pilotManager_schoolType");
      var schoolPrivince = sessionStorage.getItem("wlx_pilotManager_schoolPrivince");
      var pageSize = sessionStorage.getItem("wlx_pilotManager_pageSize");
      var page = sessionStorage.getItem("wlx_pilotManager_page");
      if(schoolName != null && schoolName != undefined){
        this.schoolName = schoolName;
      }
      if(schoolLevel != null && schoolLevel!= undefined && schoolLevel!="null"){
        this.schoolLevel = schoolLevel;
      }
      if(schoolType != null&& schoolType != undefined&&schoolType!="null"){
        this.schoolType = schoolType;
      }
      if(schoolPrivince != null && schoolPrivince != undefined && schoolPrivince!="null"){
        this.schoolPrivince = schoolPrivince;
      }
      if(pageSize != null&&pageSize != undefined){
        this.pageSize = Number(pageSize);
      }
      if(page != null && page != undefined){
        this.page = Number(page);
      }
    },
  }
};
</script>
<style lang="scss">
.yk-wrap-fixed{
    .el-input--suffix .el-input__inner {
      padding-right: 30px;
      height: 34px;
  }
    .wl-pagination-text{
      text-align: center;
      margin-top: 30px;
    }
    .site-manager-head-con{
      text-align: right;
    }
    .el-form-item__content{
      .el-button{
        padding: 8px 15px;
      }
    }
  }
  .wlx-site-manager-wrapper{
      .export-button-a{
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
      }
  }
</style>
